import { IonContent } from '@ionic/react'
import { PropsWithChildren } from 'react'

import { PageContentContainer } from '@apps-common/components/layout'

interface ItemProps {
  id?: string
  header?: any
  ionClasses?: string
  ionStyle?: any
  bgClasses?: string
  overlayClasses?: string
  onScroll?: (top: number) => void
  noSidebar?: boolean
  scrollY?: boolean
  contentScrollable?: boolean
  contentOverflowVisible?: boolean
  forceOverscroll?: boolean
}

export const LayoutContainer = ({
  id,
  header,
  ionClasses,
  ionStyle,
  bgClasses,
  overlayClasses,
  onScroll,
  scrollY = true,
  contentScrollable = true,
  contentOverflowVisible,
  forceOverscroll = false,
  children,
  noSidebar
}: PropsWithChildren<ItemProps>) => (
  <IonContent
    id='ion-content-main'
    scrollEvents={!!onScroll && scrollY}
    onIonScroll={(e) => {
      if (onScroll && e?.detail?.scrollTop) {
        onScroll(e?.detail?.scrollTop)
      }
    }}
    className={ionClasses}
    style={ionStyle}
    forceOverscroll={forceOverscroll}
    scrollY={scrollY}
  >
    <PageContentContainer
      id={id}
      bgClasses={bgClasses}
      overlayClasses={overlayClasses}
      noSidebar={noSidebar}
      scrollable={contentScrollable}
      overflowVisible={contentOverflowVisible}
    >
      {children}
    </PageContentContainer>
  </IonContent>
)
